import { FontWeight } from '@quicktools/shared-components/styles';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    root: {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: 'fit-content',
      '&:hover': {
        '& div': {
          visibility: 'visible',
        },
      },
    },
    label: {
      'user-select': 'none',
      whiteSpace: 'break-spaces',
      fontSize: 14,
      lineHeight: '20px',
      fontWeight: FontWeight.SemiBold,
    },
    requiredStar: {
      marginLeft: 4,
      display: 'inline-block',
      '& > svg': {
        verticalAlign: 'super',
      },
    },
    info: {
      marginLeft: 4,
      display: 'inline-block',
      '& > svg': {
        verticalAlign: 'middle',
        width: 16,
        height: 16,
        '& > path': {
          fill: 'black',
        },
      },
    },
    toolTip: {
      position: 'absolute',
      zIndex: 100,
      visibility: 'hidden',
    },
  },
  { name: 'text-label' },
);
export default useStyles;
